module.exports = __webpack_public_path__ + "static/media/fly0124.7c8eb55f.webp";